import NumInput from './NumInput';
export default NumInput;
